import React from 'react'
import "./DrinkWater.css"

function DrinkWater() {
  return (
    <div className='drinkwater-container'>
      <div className="drinkwater-content">

        <div className='drinkwater-header'>
          <h3>İÇME SUYU UYUMLU KAUÇUK HAMURLAR</h3>
        </div>
        <div className='pro-text-promotion'>
          <h3>İÇME SUYU UYUMLU KAUÇUK HAMURLAR</h3>
          <p>
            İçme suyuyla temas halinde olabilecek sızdırmazlık parçalarının üretimi için özel olarak geliştirilen hamurlarımız BRL, KTW, NSF gibi uluslararası standartları karşılayan, aynı zamanda Isıya, ozona ve güneş ışığına karşı mükemmel direnç gösteren, soğuk ve sıcak suya karşı üstün dayanıklılığa sahip kauçuk hamurlarımızla hizmetinizdeyiz.
          </p>


        </div>




        <div className='drinkwater-features'>
          <div className='drinkwater-features-header'>
            <h3>ÜRÜN ÖZELLİKLERİ</h3>
          </div>
          <p><strong>Elastomer :</strong>EPDM,NBR based compounds</p>
          <p><strong>Sertlik :</strong>60-75 ShA</p>
          <p><strong>Çapraz Bağlama :</strong>peroksit pişirici</p>
          <div>
            <strong>- W270</strong>
            <strong>- UBA</strong>
            <strong>- BRL 17504</strong>
            <strong>- KTW</strong>
            <strong>- ACS</strong>
            <strong>- WRAS BS 6920</strong>
            <strong>- NSF/ANSI 61</strong>
          </div>
          <p>normlarına uygun</p>


        </div>



        <div className='info-contact'>
          <button className='btn-contact'>Teklif almak için bizimle iletişime geçebilirsiniz</button>
        </div>

      </div>
    </div>
  )
}

export default DrinkWater